// extracted by mini-css-extract-plugin
module.exports = {"opcoes":"OpcoesTab_opcoes__1TLDM","imagem":"OpcoesTab_imagem__dYipZ"};